import {
  AiAssistantEditModel,
  AiAssitantChatMessage,
  MyAssitantListItem,
} from '../models/AI/AiAssistantModels';
import {ApiResponse} from '../models/ApiResponse';
import {apiClient} from './baseApiClient';

class AiAssitantsApi {
  public getMyAssistants(
    courseId?: string,
  ): Promise<ApiResponse<MyAssitantListItem[]>> {
    if (courseId) {
      return apiClient.get(`/AiAssistant/my_assistants?courseId=${courseId}`);
    }
    return apiClient.get(`/AiAssistant/my_assistants`);
  }

  public clearAiAssistantChat(assistantid: string): Promise<ApiResponse<any>> {
    return apiClient.post(`/AiAssistant/clear_history/${assistantid}`);
  }
  public clearAiAssistantPublicChat(
    assistantid: string,
    sessionId: string,
  ): Promise<ApiResponse<any>> {
    //return apiClient.post(`/AiAssistant/clear_history/${assistantid}`);
    return apiClient.post(
      `/AiAssistant/public/clear_history/${assistantid}?sessionId=${sessionId}`,
    );
  }

  public async sendAssistantChat(
    organizationId: string,
    assistantId: string,
    question: string,
  ): Promise<
    ApiResponse<{
      chat_history: AiAssitantChatMessage[];
    }>
  > {
    return apiClient.post(
      `/VideoQuestions/${organizationId}/ai_assistant/chat`,
      {
        question,
        assistantId,
      },
    );
  }

  public async sendAssistantPublicChat(
    organizationId: string,
    assistantId: string,
    sessionId: string,
    question: string,
  ): Promise<
    ApiResponse<{
      chat_history: AiAssitantChatMessage[];
    }>
  > {
    return apiClient.post(`/AiAssistant/${organizationId}/public/chat`, {
      question,
      assistantId,
      sessionId,
    });
  }

  public getAssitantForEditing(
    organicationId: string,
    assistantId: string,
  ): Promise<ApiResponse<AiAssistantEditModel>> {
    return apiClient.get(
      `/videoQuestions/${organicationId}/ai_assistant/${assistantId}`,
    );
  }
}

export default AiAssitantsApi;
